import { useState } from "react";
import { Box, Stack, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useDispatch } from "react-redux";
import { LAYOUT_MARGIN } from "Configs/home";

import useWindowSize from "Hooks/useWindowSize";
import { useAppSelector } from "Hooks/useRedux";

import Toolbox from "./Toolbox";
import Tooltip from "../Tooltip";
import Operation from "../Operation";
import Inventory from "./side/inventory";
import Tickets from "./side/tickets";
import TicketDetail from "../side/leftSide/TicketDetail";
import LocationData from "../LocationData";
import Modals from "../Modals";
import LeftSideController from "./side/leftSideControl";
import SimpleDashboard from "../side/leftSide/simpleDashboard";
import Contact from "./contact";
import FleetDialoig from "./fleetDialog";
import Calling from "./calling";
import RightSideController from "./side/rightSideControl";
import Passenger from "./side/passenger";

export default function Reports() {
  const { width, height } = useWindowSize();
  const { fullScreen } = useAppSelector((state) => state.services);
  const { supportRightSideMode, showPaths, supportLeftSideMode } = useAppSelector((state) => state.supportSide);
  const [rightPositions, setRightPositions] = useState<any>([0, -100, 100]);
  const { isCalling } = useAppSelector((state) => state.contact);

  const dispatch = useDispatch();

  return (
    <>
      <Box sx={{ position: "absolute", top: LAYOUT_MARGIN, left: LAYOUT_MARGIN, width: "380px", zIndex: "2" }}>
        <Operation />
      </Box>

      <Box
        sx={{
          position: "absolute",
          top: fullScreen ? 2 : LAYOUT_MARGIN + 56,
          right: LAYOUT_MARGIN,
          width: fullScreen ? `calc(100% - ${LAYOUT_MARGIN * 2}px)` : "400px",
          zIndex: fullScreen ? "1001" : "",
          transition: "all 0.3s",
        }}
      >
        {/* <Contact /> */}
        <Passenger />
      </Box>

      {isCalling ? (
        <Box
          sx={{
            position: "absolute",
            top: " 35%",
            right: "35%",
            width: "30%",
            height: "30%",
            zIndex: fullScreen ? "1001" : "",
            transition: "all 0.3s",
          }}
        >
          <Calling />
        </Box>
      ) : null}

      <Box sx={{ position: "absolute", top: LAYOUT_MARGIN + 56, left: LAYOUT_MARGIN, width: "380px", zIndex: "2" }}>
        {supportRightSideMode === 1 ? <Inventory /> : null}
        {supportRightSideMode === 2 ? <Tickets /> : null}
      </Box>

      <Box sx={{ position: "absolute", top: LAYOUT_MARGIN, right: LAYOUT_MARGIN }}>
        <LocationData />
      </Box>

      <Stack
        direction="row"
        spacing={1}
        sx={{
          width: `calc(100% - ${LAYOUT_MARGIN * 2}px)`,
          position: "absolute",
          bottom: LAYOUT_MARGIN,
          left: LAYOUT_MARGIN,
        }}
      >
        {/* <RightSideController /> */}
        <Tooltip bgcolor="#11d7af" />
        <Toolbox />
        <FleetDialoig />
      </Stack>
      <Modals />
    </>
  );
}
